import { Button } from '@mui/material';
import { ChevronDown, ChevronUp, NotebookTabs, Search } from 'lucide-react';
import { contractCurrencyFormatter } from '../../utils/contractsData';
import { InputTextField } from '../Input/InputTextField';

const formatContractRate = (rate) => {
  if (rate === null || rate === undefined || rate === '') {
    return '';
  }

  const numericRate = Number(String(rate).replace(/[$,]/g, ''));
  return Number.isNaN(numericRate) ? rate : contractCurrencyFormatter.format(numericRate);
};

const LocalContracts = ({
  searchTerm,
  setSearchTerm,
  handleCreateContract,
  selectedAccountName,
  visibleContracts,
  handleDateSort,
  dateSortDirection,
  formatContractDate,
  showAccountSubtitle = true,
}) => {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, marginBottom: 20, padding: '0 4px' }}>
        <div style={{ flex: 1, maxWidth: 360 }}>
          <InputTextField
            onChange={setSearchTerm}
            placeholder='Search contract'
            value={searchTerm}
            endIcon={<Search size={16} />}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateContract}
        >
          <NotebookTabs className="nav-icon" style={{ marginRight: 11 }} size={16} /> Create contract
        </Button>
      </div>

      <div className="data-feed-panel contract-panel--table" role="tabpanel">
        <div className="contract-panel__header">
          <div>
            <h3 className="contract-panel__title">Active Contracts</h3>
            {showAccountSubtitle && (
              <p className="contract-panel__subtitle">
                {selectedAccountName ? `Showing contracts for ${selectedAccountName}` : 'Showing contracts for selected account'}
              </p>
            )}
          </div>
          <p className="contract-panel__count">
            {visibleContracts.length} contract{visibleContracts.length === 1 ? '' : 's'}
          </p>
        </div>

        <div className="data-feed-table-wrapper contract-table-wrapper">
          <table className="data-feed-table contract-table">
            <thead>
              <tr className="data-feed-table__header-row">
                <th className="data-feed-table__header-cell contract-table__header-cell">
                  Member ID / Patient ID
                </th>
                <th className="data-feed-table__header-cell contract-table__header-cell">
                  <button
                    type="button"
                    onClick={handleDateSort}
                    className="contract-table__sort-button"
                  >
                    Date
                    <span className="contract-table__sort-icons">
                      <ChevronUp
                        size={12}
                        style={{ color: dateSortDirection === 'asc' ? 'var(--brand-blue)' : 'var(--text-muted)' }}
                      />
                      <ChevronDown
                        size={12}
                        style={{ color: dateSortDirection === 'desc' ? 'var(--brand-blue)' : 'var(--text-muted)' }}
                      />
                    </span>
                  </button>
                </th>
                <th className="data-feed-table__header-cell contract-table__header-cell">
                  Rate
                </th>
              </tr>
            </thead>
            <tbody>
              {visibleContracts.length > 0 ? (
                visibleContracts.map((contract) => (
                  <tr key={contract.id}>
                    <td className="data-feed-table__cell contract-table__cell">
                      {contract.memberId}
                    </td>
                    <td className="data-feed-table__cell contract-table__cell">
                      {formatContractDate(contract.date)}
                    </td>
                    <td className="data-feed-table__cell contract-table__cell">
                      {formatContractRate(contract.rate)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="data-feed-table__empty-cell">
                    No contracts found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default LocalContracts;
